<div class="loading__inner">
  <div class="loading__overlay"></div>
  <ng-content select="[above-message]"></ng-content>
  <spinner [size]="size" [color]="color"></spinner>
  <ng-content></ng-content>
</div>
